import { T } from "../lib/globals";
import React, { useState } from "react";
import { Btn, Field, Modal, Textarea } from "./ui";
import { getMaterialUsageQty } from "../lib/materialHelpers";

function MaterialRestockModal({ title = "Estorno de Materiais", recordLabel = "", materials = [], onClose, onConfirm }) {
  const [note, setNote] = useState("");
  const totalItems = materials.reduce((sum, m) => sum + getMaterialUsageQty(m), 0);
  return (
    <Modal open={true} onClose={onClose} title={title} wide zIndex={460}>
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <div style={{ fontSize: 13, color: T.text, fontWeight: 700 }}>{recordLabel || "Registro"}</div>
        <div style={{ fontSize: 12, color: T.muted, lineHeight: 1.45 }}>
          Para excluir este registro, é necessário devolver ao estoque todos os materiais consumidos. Confira abaixo e confirme o estorno para habilitar a exclusão.
        </div>
        <div style={{ display: "grid", gap: 8 }}>
          {materials.map((m, idx) => (
            <div key={`${m.stockId || 'item'}_${idx}`} style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10, alignItems: "center", padding: "10px 12px", background: T.card2, border: `1px solid ${T.border}`, borderRadius: 10 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: T.text }}>{m.name || m.stockId}</div>
                <div style={{ fontSize: 11, color: T.muted }}>Retorno integral ao estoque</div>
              </div>
              <div style={{ fontSize: 13, fontWeight: 800, color: T.accent, whiteSpace: "nowrap" }}>{getMaterialUsageQty(m)} {m.unit || "un"}</div>
            </div>
          ))}
        </div>
        <Field label="Observação do estorno" col="1/-1">
          <Textarea rows={2} value={note} onChange={e => setNote(e.target.value)} placeholder="Opcional. Ex.: exclusão do registro após devolução dos materiais." />
        </Field>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, paddingTop: 6, borderTop: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 12, color: T.muted }}>Total a devolver: <strong style={{ color: T.text }}>{totalItems}</strong></div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn variant="ghost" onClick={onClose}>Cancelar</Btn>
            <Btn onClick={() => onConfirm(note)}>Confirmar estorno</Btn>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default MaterialRestockModal;
export { MaterialRestockModal };
